<template>
  <div class="intro">
    <div class="intro__logo">
      <span class="intro__glow"></span>
      <ParkosMark :size="54" on-dark class="intro__mark" />
      <span class="intro__word">Parkos</span>
    </div>

    <h1 class="intro__welcome">
      <span class="intro__line">Bienvenido a Parkos<template v-if="firstName">,</template><template v-else>.</template></span>
      <span v-if="firstName" class="intro__line intro__line--name">{{ firstName }}</span>
    </h1>
    <p class="intro__sub">Vamos a configurar tu parque en unos minutos.</p>

    <div class="intro__actions">
      <button type="button" class="intro__start" @click="$emit('start')">Comenzar configuración →</button>
      <button type="button" class="intro__skip" @click="$emit('skip')">Saltar configuración y entrar al sistema</button>
    </div>
  </div>
</template>

<script setup>
import ParkosMark from '@/components/Global/ParkosMark.vue'
import { computed } from 'vue'
import { ob } from '@/services/onboardingStore'

defineEmits(['start', 'skip'])

const firstName = computed(() => (ob.userName || '').trim().split(/\s+/)[0] || '')
</script>

<style scoped>
.intro { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 24px; text-align: center; color: #fff; }

/* Línea de tiempo: negro 0.3 s → logo 0.6 s → saludo → subtítulo → botón (≈2.4 s en total). */
.intro__logo { position: relative; display: flex; align-items: center; gap: 12px; width: 180px; justify-content: center; margin-bottom: 36px; animation: logoIn 0.6s 0.3s both; }
.intro__mark { font-size: 54px; line-height: 1; }
.intro__word { font: 500 34px var(--font-body); letter-spacing: -0.01em; }
.intro__glow { position: absolute; inset: -30px -20px; background: #3b82f6; filter: blur(40px); border-radius: 50%; opacity: 0.25; z-index: -1; animation: glowIn 0.6s 0.3s both; }

.intro__welcome { margin: 0; display: flex; flex-direction: column; gap: 2px; font: 700 28px var(--font-display); }
.intro__line { animation: riseIn 0.4s 1.2s both; }
.intro__line--name { color: #60a5fa; animation-delay: 1.3s; }
.intro__sub { margin: 14px 0 0; font: 400 16px var(--font-body); color: rgba(255, 255, 255, 0.7); animation: riseIn 0.4s 1.6s both; }

.intro__actions { margin-top: 36px; display: flex; flex-direction: column; align-items: center; gap: 18px; animation: buttonIn 0.3s 2.1s both; }
.intro__start { height: 52px; padding: 0 32px; border: none; border-radius: 8px; background: #3b82f6; color: #fff; font: 500 15px var(--font-body); cursor: pointer; box-shadow: 0 0 24px rgba(59, 130, 246, 0.5); transition: background 0.15s, box-shadow 0.15s; }
.intro__start:hover { background: #2563eb; box-shadow: 0 0 36px rgba(59, 130, 246, 0.75); }
.intro__start:focus-visible { outline: 2px solid #fff; outline-offset: 3px; }
.intro__skip { background: none; border: none; cursor: pointer; font: 400 12px var(--font-body); color: rgba(255, 255, 255, 0.4); transition: color 0.15s; }
.intro__skip:hover, .intro__skip:focus-visible { color: rgba(255, 255, 255, 0.7); }

@keyframes logoIn {
  0% { transform: scale(0); opacity: 0; animation-timing-function: ease-out; }
  66.7% { transform: scale(1.1); opacity: 1; animation-timing-function: ease-in; }
  100% { transform: scale(1); opacity: 1; }
}
@keyframes glowIn {
  0% { opacity: 0; }
  66.7% { opacity: 0.4; }
  100% { opacity: 0.25; }
}
@keyframes riseIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
@keyframes buttonIn { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }

@media (prefers-reduced-motion: reduce) {
  .intro__logo, .intro__glow, .intro__line, .intro__sub, .intro__actions { animation-duration: 0.01ms; animation-delay: 0s; }
}
</style>